var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      attrs: { placement: "bottom", width: "400", trigger: "click" },
      on: { show: _vm.getBranchInfo }
    },
    [
      _c("div", { staticClass: "branch-info" }, [
        _c("div", { staticClass: "branch-title" }, [
          _vm._v(_vm._s(_vm.branchInfo.branchTeam))
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content-container" },
          _vm._l(_vm.contentList, function(item, index) {
            return _c("div", { key: index, staticClass: "content-item" }, [
              _c("div", { staticClass: "label" }, [_vm._v(_vm._s(item.label))]),
              _vm._v(" "),
              _c("div", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.branchInfo[item.value]))
              ])
            ])
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("i", {
        staticClass: "el-icon-question popover-icon",
        attrs: { slot: "reference" },
        slot: "reference"
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45627380", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45627380","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/branchInfo.vue
// module id = null
// module chunks = 